import React from 'react';

const CheckTick = ({ width = 16, height = 16, color = '#424242' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 17" fill="none">
      <path
        d="M2.75 9.25L6.25 12.75L13.25 5.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLineJoin="round"
      />
    </svg>
  );
};

export default CheckTick;
